import { BASE_API_URL } from "./app-constants";

const prefix = BASE_API_URL + "/uploads/";

export function getFileName(url: string): string {
  url = decodeURIComponent(url);
  return url.replace(prefix, "");
}

export default function get_file_url(name: string) {
  return `${prefix}${name}`;
}
